import SubLabel from "components/Atoms/Sublabel";
import PanelSegment from "components/panels/PanelSegment/PanelSegment";
import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import Table from "components/Tables/Table";
import React from "react";
import { formatTimeZone, getTimeZoneFromIana } from "shared/utils/dateTimeUtils";
interface Props {
  states: server.dto.State[]
  countryName: string
}

const StatesTablePanel = (props: Props) => {


  return <SectionPanel.Panel
    header={<>
      <PanelSegment.Title title={RESX.Address.XStatesInY.replace("{0}", props.states.length.toString()).replace("{1}", props.countryName)} />
    </>}
  >
    <Table
      items={props.states}
      isLoading={false}
      getKey={state => state.key.toString()}
      columns={[
        {
          key: "name",
          header: RESX.GeneralLabels.Name,
          render: (state) => <div>
            <div>{state.name}</div>
            <div><SubLabel>{state.code}</SubLabel></div>
          </div>,
        }, {
          key: "timezone",
          header: `${RESX.GeneralLabels.NumberAndDate} / ${RESX.DateTime.Timezone}`,
          render: (state) => <div>
            <div>{state.cultureName}</div>
            <div>
              <SubLabel>{state.ianaTimeZoneId}</SubLabel>
              <SubLabel>{formatTimeZone(getTimeZoneFromIana(state.ianaTimeZoneId, serverReference.culture.uiLanguage))}</SubLabel>
            </div>
          </div>,
        }, {
          key: "language",
          header: RESX.Language.resxLanguage,
          render: (state) => {
            return <div>
              {state.language}
            </div>
          }
        }, {
          key: "systemOneId",
          header: "SystemOne ID",
          render: (state) => {
            return <div>
              {state.key}
            </div>
          }
        }
      ]}
    />
  </SectionPanel.Panel>
}

export default StatesTablePanel;